/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React, { useState } from 'react';
import { Card, Button, Modal } from 'react-bootstrap';
import {
  TimelineMercury,
  ITimelineMercuryProps,
} from '@vlinder-web/timeline-mercury-widget-react';

export interface IEventTimelineModal {
  showModal?: boolean;
  modalTitle?: string;
  timelineData?: ITimelineMercuryProps;
  onDeny?(): void;
}

export const EventTimelineModal = (props: IEventTimelineModal) => {
  const { showModal, modalTitle, timelineData, onDeny } = props;
  const [show, setShow] = useState(showModal);

  const handleClose = () => {
    if (onDeny) {
      onDeny();
    }
    setShow(false);
  };

  return (
    <Modal
      centered
      show={show}
      onHide={handleClose}
      scrollable={true}
      size={'lg'}
      fullscreen={'xxl-down'}
    >
      <Modal.Header className="border-0">
        <h4>{modalTitle}</h4>
        <Button variant="close" aria-label="Close" onClick={handleClose} />
      </Modal.Header>
      <Modal.Body className="p-0">
        <Card border="light" className="px-0 px-md-4 py-0 border-0">
          <Card.Body>
            <TimelineMercury items={timelineData} />
          </Card.Body>
        </Card>
      </Modal.Body>
    </Modal>
  );
};
